export const countdownSecs = 5;
